import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=7f69c16b&"
import script from "./Infos.vue?vue&type=script&lang=js&"
export * from "./Infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f69c16b')) {
      api.createRecord('7f69c16b', component.options)
    } else {
      api.reload('7f69c16b', component.options)
    }
    module.hot.accept("./Infos.vue?vue&type=template&id=7f69c16b&", function () {
      api.rerender('7f69c16b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/SPFPlayer/lib/Infos.vue"
export default component.exports